import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";

import { CareProtocolOpportunityHistoryListV2 } from "../../../components/v2";

export function CareProtocolOpportunitiesPageV2() {
  return (
    <VerticalFlexbox className="mx-auto min-h-full w-full max-w-[860px] bg-background px-[18px] pb-8 pt-4">
      <CareProtocolOpportunityHistoryListV2 />
    </VerticalFlexbox>
  );
}
